import * as React from 'react'
import SkuItem from './sku-item';
import * as classnames from "classnames"

export default function SkuList ( props: any ) {
    const { skuAttrs, skuInfoMap } = props;

    return skuAttrs.map( ( { name,values,id }: any,index: React.Key ) => (
        <div key={index} className={classnames( {
            "sku-item": true,
            "sku-last": index === skuAttrs.length - 1
        } )}>
            <label>{name}</label>
            <SkuItem {...props} skuInfoMap={skuInfoMap} list={values} id={id} index={index} isLast={index === skuAttrs.length - 1}/>
        </div>
    ) )
}
